import { createNamespace } from './base'

const send = createNamespace( '/api/doctor-landing-data' )

const DoctorLandingDataAPI = {
    getById: ({id}) => send({ action: 'get-preview-by-user-id', data: {id} })
}

export default DoctorLandingDataAPI